
const axios = require("axios")
const uuid = require("uuid")
const Vue = require("vue").default
const utils = require("./Utils.js")

var hostname = process.env.VUE_APP_HOSTNAME
var authHostname = process.env.VUE_APP_AUTH_HOSTNAME
var appApiVersion = process.env.VUE_APP_API_VERSION
var authApiVersion = process.env.VUE_APP_AUTH_API_VERSION
var protocol = process.env.VUE_APP_PROTOCOL

var apiConfig = {
    logout: function(){
        return {
            type: "GET",
            url: protocol + "://"+authHostname+"/"+authApiVersion+"/logout",
            bodyString: null,
            config: {
                withCredentials: true,
            }
        }
    },
    refreshToken: function(){
        return {
            type: "POST",
            url: protocol + "://"+authHostname+"/"+authApiVersion+"/refresh_token",
            bodyString: null,
            config: {
                withCredentials: true,
            }
        }
    },
    createNewCollection: function(bodyString){
        return {
            type: "POST",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/collection",
            bodyString: bodyString,
            config: null
        }
    },
    addNewFlashcard: function(bodyString){
        return {
            type: "POST",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/flashcard",
            bodyString: bodyString,
            config: null
        }
    },
    getAllCollections: function(){
        return {
            type: "GET",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/collections",
            bodyString: null,
            config: null
        }
    },
    getCardsInCollection: function(collId){
        return {
            type: "GET",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/collection",
            bodyString: null,
            config: {
                params: {
                    collId: collId
                }
            },
            
        }
    },
    deleteFlashcard: function(bodyString){
        return {
            type: "DELETE",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/flashcard",
            configWithBodyStringAsData: {
                data: bodyString
            }
        }
    },
    deleteCollection: function(bodyString){
        return {
            type: "DELETE",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/collection",
            configWithBodyStringAsData: {
                data: bodyString
            }
        }
    },
    updateCollection: function(bodyString){
        return {
            type: "PUT",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/collection",
            bodyString: bodyString
        }
    },
    updateFlashcard: function(bodyString){
        return {
            type: "PUT",
            url: protocol + "://"+hostname+"/"+appApiVersion+"/flashcard",
            bodyString: bodyString
        }
    },
    login: function(bodyString){
        return {
            type: "POST",
            url: protocol + "://"+authHostname+"/"+authApiVersion+"/login",
            bodyString: bodyString,
            config: {
                withCredentials: true,
            }

        }
    }
}

function ConnectionManager(){
    var eventBus = new Vue();

    return {
        newConnection: function(api, maxTryCount_){
            return new connection(api, maxTryCount_, eventBus)
        },
        getEventBus: function(){
            return eventBus
        }
    }

}

function connection(api, maxTryCount_, eventBus){
    var maxTryCount = maxTryCount_ || 1
    var taskId = uuid.v4()

    return {
        do: async function(){
            var tryCount = 0
            var refreshTokenApi = apiConfig.refreshToken()
            var res
            eventBus.$emit("newConnection", taskId)

            while (tryCount <= maxTryCount){
                try {
                    switch (api.type){
                        case "GET":
                            res = await axios.get(api.url, api.config)
                            eventBus.$emit("closeConnection", taskId)
                            return res
                        case "POST":
                            res = await axios.post(api.url, api.bodyString, api.config)
                            eventBus.$emit("closeConnection", taskId)
                            return res
                        case "DELETE":
                            res = await axios.delete(api.url, api.configWithBodyStringAsData)
                            eventBus.$emit("closeConnection", taskId)
                            return res
                        case "PUT":
                            res = await axios.put(api.url, api.bodyString)
                            eventBus.$emit("closeConnection", taskId)
                            return res
                    }
                } catch (e){
                    if (tryCount >= maxTryCount) {
                        alert("Network error")
                        eventBus.$emit("closeConnection", taskId)
                        throw e
                    }

                    if (e.response.status === 401){
                        try {
                            res = await axios.post(refreshTokenApi.url, refreshTokenApi.bodyString, refreshTokenApi.config)
                        } catch (e){
                            if (e.response.status === 502){
                                utils.clearUserId()
                                location.reload()
                            }
                        }
                    
                        var user = res.data.user
                        window.localStorage.setItem('uid', user.userId)
                        window.localStorage.setItem('username', user.username)
                        window.localStorage.setItem('jwt', res.data.jwt)
                        axios.defaults.headers.common['authorizationToken'] = window.localStorage.getItem("jwt")
                    } else {
                        alert("Network error")
                        eventBus.$emit("closeConnection", taskId)
                        throw e
                    }
                }
                tryCount++
            }
            eventBus.$emit("closeConnection", taskId)
            return res
        }
    }
}


module.exports = {
    ConnectionManager: new ConnectionManager(),
    API: apiConfig
}
